import React from "react";
import { settings } from "./settings/configuration";

export const STATUS_OFFLINE = 1;
export const STATUS_ONLINE_NOCONNECTION = 2;
export const STATUS_ONLINE = 3;
export const STATUS_SYNCED = 4;

export const GROUP_VARIABLE = {
  1: "fuelers",
  2: "maintainers",
  3: "admins",
};

export const main = {
  constants: {
    FUELERS: "Fuelers",
    MAINTAINERS: "Maintainers",
    ADMINS: "Admins",
    VENDOR_ADMINS: "Vendor Admins",
    SUPER_ADMINS: "Super Admins",
    SUPERINTENDENT: "Superintendent",
    AIRLINES: "Airlines",
    AIRPORTAUTHORITY: "Airport Authority",
  },
  groups: {},
  status: {
    authorized: false,
    username: "Vladimir",
    password: "",
    group: "",
    id: "",
    first_name: "Vladimir",
    last_name: "Vladimir",
    photo: null,
    has_station: null,
    is_nata_user: false,
    station_id: null,
    station: "",
    vendor_id: null,
    vendor: "",
    preferences: {},
    can_change_prefs: false,
    date_string: "",
  },
  flash_audit_status: {
    active_flash_audits: 0,
    pending_items: 0,
  },
  fso_status: {
    pending: false,
    equipmentId: -1,
  },
  inspections: null,
  equipmentTypes: {},
  data: null,
  saves: [],
  vendors: [],
  operations: [],
  done_intercompany: {},
};

export const configuration = {
  settings: {
    url: settings.url,
    subfolder: settings.subfolder,
  },
  update_main_context: () => {},
  update_ui_context: () => {},
  time_zone: null,
};

export const uicontext_data = {
  error: "",
  online_status: STATUS_ONLINE,
  modal: {
    header: "",
    errorHtml: "",
    url: "",
    footerType: "",
  },
};

export const MainContext = React.createContext(main);
export const UpdateContext = React.createContext(configuration);
export const UIContext = React.createContext(uicontext_data);
